module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"serviceManageMenu.editSpendLimit":"Set Spend Limit"}}')
  delete Component.options._Ctor
}
